module.exports = __webpack_public_path__ + "img/training.9cb67cb4.svg";